// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BookableController from "./bookable_controller"
application.register("bookable", BookableController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CardSettingsController from "./card_settings_controller"
application.register("card-settings", CardSettingsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import FetchQrcodeDataController from "./fetch_qrcode_data_controller"
application.register("fetch-qrcode-data", FetchQrcodeDataController)

import InputFieldComponentController from "./input_field_component_controller"
application.register("input-field-component", InputFieldComponentController)

import InviteesController from "./invitees_controller"
application.register("invitees", InviteesController)

import InvolvementsController from "./involvements_controller"
application.register("involvements", InvolvementsController)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import PaginationComponentController from "./pagination_component_controller"
application.register("pagination-component", PaginationComponentController)

import ScannerController from "./scanner_controller"
application.register("scanner", ScannerController)

import SearchComponentController from "./search_component_controller"
application.register("search-component", SearchComponentController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SearchFormComponentController from "./search_form_component_controller"
application.register("search-form-component", SearchFormComponentController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
